import { render, staticRenderFns } from "./FormatEventGross.vue?vue&type=template&id=05834de8&"
import script from "./FormatEventGross.vue?vue&type=script&lang=ts&"
export * from "./FormatEventGross.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports